var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    staticClass: "sub-visual sub-visual--sv6"
  }, [_c('v-container', [_c('h2', {
    staticClass: "sub-visual__title color-white"
  }, [_c('span', [_vm._v("DEMO")])])])], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('h6', {
    staticClass: "page-text-lg font-weight-bold text-center mb-30 mb-lg-52"
  }, [_vm._v(" " + _vm._s(_vm.settings.demo) + " ")]), _c('p', {
    staticClass: "text-right page-text-sm line-height-1 mb-4 mb-lg-8"
  }, [_c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")]), _vm._v(" This is a required data entry")]), _c('div', {
    staticClass: "table-style table-style--default"
  }, [_c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Name "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "Name",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.demo.name,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "name", $$v);
      },
      expression: "demo.name"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Contact information "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.prependPhones,
      "placeholder": "contact information",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input() {
        return _vm.phoneNumberJoin();
      }
    },
    model: {
      value: _vm.phone1,
      callback: function callback($$v) {
        _vm.phone1 = $$v;
      },
      expression: "phone1"
    }
  }, 'v-select', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input() {
        return _vm.phoneNumberJoin();
      }
    },
    model: {
      value: _vm.phone2,
      callback: function callback($$v) {
        _vm.phone2 = $$v;
      },
      expression: "phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "maxlength": "4",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input() {
        return _vm.phoneNumberJoin();
      }
    },
    model: {
      value: _vm.phone3,
      callback: function callback($$v) {
        _vm.phone3 = $$v;
      },
      expression: "phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Email "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "Email",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input() {
        return _vm.emailJoin();
      }
    },
    model: {
      value: _vm.email1,
      callback: function callback($$v) {
        _vm.email1 = $$v;
      },
      expression: "email1"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("@")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input() {
        return _vm.emailJoin();
      }
    },
    model: {
      value: _vm.email2,
      callback: function callback($$v) {
        _vm.email2 = $$v;
      },
      expression: "email2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "persistent-hint": "",
      "items": _vm.prependEmails,
      "item-text": "text",
      "item-value": "value",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "input": function input($event) {
        _vm.email2 = _vm.email3;
      }
    },
    model: {
      value: _vm.email3,
      callback: function callback($$v) {
        _vm.email3 = $$v;
      },
      expression: "email3"
    }
  }, 'v-select', _vm.$attrs, false))], 1)], 1)], 1)], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Company name "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "Company name",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.demo.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "companyName", $$v);
      },
      expression: "demo.companyName"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Environment of Use "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "[Windows], [Linux{CentOS, Ubuntu}]..",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.demo.os,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "os", $$v);
      },
      expression: "demo.os"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("WEB Servers /WAS Type "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "placeholder": "WEB Servers /WAS Type",
      "outlined": "",
      "hide-details": "",
      "clearable": ""
    },
    model: {
      value: _vm.demo.server,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "server", $$v);
      },
      expression: "demo.server"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Operating agency required "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-radio-group', {
    attrs: {
      "row": "",
      "hide-details": ""
    },
    model: {
      value: _vm.demo.need,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "need", $$v);
      },
      expression: "demo.need"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Required",
      "value": "필요",
      "color": "primary"
    }
  }), _c('v-radio', {
    attrs: {
      "label": "Not required",
      "value": "불필요",
      "color": "primary"
    }
  })], 1)], 1)])], 1)], 1)]), _c('div', {
    staticClass: "table-style__row"
  }, [_c('div', {
    staticClass: "table-style__th"
  }, [_vm._v("Other inquiries "), _c('span', {
    staticStyle: {
      "color": "#ff2d2d"
    }
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "table-style__td"
  }, [_c('v-row', {
    staticClass: "row--x-small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "my-6px"
  }, [_c('v-textarea', {
    attrs: {
      "rows": "9",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.demo.content,
      callback: function callback($$v) {
        _vm.$set(_vm.demo, "content", $$v);
      },
      expression: "demo.content"
    }
  })], 1)])], 1)], 1)])]), _c('div', {
    staticClass: "mt-30 mt-lg-60 text-center"
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("To apply for")])], 1)])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }